import * as types from './mutation-types'


export const loadQvctAnswerChoice = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/qvct/answers/type/collection', data).then((response) => {
            commit(types.LOAD_QVCT_ANSWER_TYPE, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const storeQvctAnswerChoice = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/qvct/answers/choice', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const updateQvctAnswerChoice = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`update/qvct/answers/choice/${data.id}`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteQvctAnswerChoice = ({commit}, {id}) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`delete/qvct/answers/choice/${id}`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
